/* eslint-disable */
import React, { useMemo, useState } from 'react';
import { CTitle, TTitle } from '../../components/Widget';
import { useParams } from 'react-router-dom';
import ToolsBox from '../../components/ToolsBox';
import ToolsTop from '../../../../../../assets/finance/topic1600/section3-bg1.png';
import ToolsBottom from '../../../../../../assets/finance/topic1600/section3-bg2.png';
import { useUpdateComponentState } from '../../../hooks';
import Quiz from '../../components/Quiz';

import icon1 from '../../../../../../assets/finance/topic1600/section3-icon1.png';
import icon2 from '../../../../../../assets/finance/topic1600/section3-icon2.png';
import icon3 from '../../../../../../assets/finance/topic1600/section3-icon3.png';
import icon4 from '../../../../../../assets/finance/topic1600/section3-icon4.png';
import icon5 from '../../../../../../assets/finance/topic1600/section3-icon5.png';
import icon6 from '../../../../../../assets/finance/topic1600/section3-icon6.png';
interface ISection0Props {
  settings: any;
}

const Section3: React.FunctionComponent<ISection0Props> = ({ settings }) => {
  const ID = '4';
  const param = useParams();
  const p_course = param.course || '';
  const p_topic = param['*'] || 'welcome';
  const paragraphsSettings = useMemo(
    () => settings?.paragraphs[3],
    [settings?.paragraphs]
  );
  const updateComponentState = useUpdateComponentState();
  const { quiz } = paragraphsSettings;
  const [quizState, setQuizState] = useState(false);
  const quizComplete = () => {
    setQuizState(true);
  };

  const iconMap: Record<number, string> = {
    1: icon1,
    2: icon2,
    3: icon3,
    4: icon4,
    5: icon5,
    6: icon6,
  };

  React.useEffect(() => {
    if (quizState) {
      console.log(222)
      updateComponentState(
        p_course,
        p_topic,
        ID,
        'finance-topic1600-section3-question'
      );
    }
  }, [p_course, p_topic, quizState]);

  const handleComplete = React.useCallback(() => {
    console.log(1111);
    updateComponentState(p_course, p_topic, ID, 'finance-topic1600-section3-1');
  }, [updateComponentState, p_course, p_topic, ID]);

  return (
    <div className="topic-section-3">
      <CTitle title={paragraphsSettings?.title} />
      <ToolsBox
        leftText={paragraphsSettings?.l3}
        rightText={paragraphsSettings?.l4}
        leftBackgroundImage={ToolsTop}
        rightBackgroundImage={ToolsBottom}
        id="finance-topic1600-section3-1"
        onComplete={handleComplete}
      />

      <div className="risk-list">
        {paragraphsSettings?.riskList?.map((risk: any, index: number) => (
          <div key={index} className={`risk-item risk-item-${index}`}>
            <div className="icon">
              <img src={iconMap[index + 1]} alt="" />{' '}
            </div>
            <div className="text">{risk}</div>
          </div>
        ))}
      </div>

      <div id="finance-topic1600-section3-question" className="topic-quiz">
        <Quiz
          title={paragraphsSettings?.questionTitle}
          description={quiz?.description}
          question={quiz?.question}
          options={quiz?.options}
          onCompleted={quizComplete}
        />
      </div>
    </div>
  );
};

export default React.memo(Section3);
